import React from "react";

const Spinner = () => {
  return (
    <div className="leap-flex leap-items-center leap-justify-center">
      <div
        className="leap-w-16 leap-h-16 leap-border-4 leap-border-solid leap-rounded-full leap-animate-spin"
        style={{
          borderColor: "#73FAFD transparent #73FAFD transparent", // Custom border color
        }}
      ></div>
    </div>
  );
};

export default Spinner;
